import { FetchRequest, FetchResponse } from '@rails/request.js'

interface CreateArgs {
  categoryId: string
  description: string
  entityId: string
}

interface UpdateArgs {
  categoryId: string
  description: string
  noteId: string
}

interface FailureResponse {
  error: string
  status: 422
}

interface SuccessResponse {
  id: string
  message: string
}

interface NoteResponse extends FetchResponse {
  get json(): Promise<FailureResponse | SuccessResponse>
}

export function create({ categoryId, description, entityId }: CreateArgs): Promise<NoteResponse> {
  const endpoint = `/admin/notes/`

  return new FetchRequest('post', endpoint, {
    body: JSON.stringify({ note: { categoryId, description, entityId } }),
  }).perform()
}

export function update({ categoryId, description, noteId }: UpdateArgs): Promise<NoteResponse> {
  const endpoint = `/admin/notes/${noteId}`

  return new FetchRequest('put', endpoint, {
    body: JSON.stringify({ note: { categoryId, description } }),
  }).perform()
}
